import { render, staticRenderFns } from "./DeliveryAdditionalInfo.vue?vue&type=template&id=762dc110&scoped=true&"
import script from "./DeliveryAdditionalInfo.vue?vue&type=script&lang=js&"
export * from "./DeliveryAdditionalInfo.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryAdditionalInfo.vue?vue&type=style&index=0&id=762dc110&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762dc110",
  null
  
)

export default component.exports